export const NOTIF_MODAL_TYPES = {
  CLOSED: 'CLOSED_MODAL',
  REG_CODE: 'REG_CODE_MODAL',
  TYPE_AND_PRIORITY: 'TYPE_AND_PRIORITY_MODAL',
  TIMES_TO_SEND_NOTIF: 'TIMES_TO_SEND_NOTIF_MODAL',
  SCHEDULE_AND_INFO: 'SCHEDULE_AND_INFO_MODAL',
  DELETE_NOTIF: 'DELETE_NOTIF_MODAL',
  DELETE_NOTIF_USER: 'DELETE_NOTIF_USER_MODAL',
  DELETE_CONTACT_MODAL: 'DELETE_CONTACT_MODAL',
  NOTIF_USER: 'NOTIF_USER_MODAL',
  STANDBY_INSPECTOR: 'STANDBY_INSPECTOR_MODAL',
};

export const SUBPAGE_TYPES = {
  NOTIFICATION: 'NOTIFICATION_SUB_PAGE',
  CONTACTS: 'CONTACTS_SUB_PAGE',
  INSPECTORS: 'INSPECTORS_SUB_PAGE',
};

export const TICKET_TYPES_TO_TEXT_MAP = {
  AMND: 'Amendment',
  DMEX: 'Damaged or exposed lines',
  DMGE: 'Damaged',
  EXPD: 'Exposed',
  NEW:  'New ticket',
  NRSP: 'No Response',
  REMK: 'Re-mark requested',
  RTRN: 'Return',
};

export const TICKET_PRIORITY_TO_TEXT_MAP = {
  NORM: 'Normal',
  SHRT: 'Short',
  RUSH: 'Rush',
  EMER: 'Emergency',
};

export const FORM_INPUT_KEYS = {
  TICKET_TYPE: 'TICKET_TYPE_FIK',
  TICKET_PRIORITY: 'TICKET_PRIORITY_FIK',
  TICKET_NAME: 'TICKET_NAME_FIK',
  TICKET_DESCRIPTION: 'TICKET_DESCRIPTION_FIK',
  TICKET_IS_ACTIVE: 'TICKET_IS_ACTIVE_FIK',
  NOTIF_USER_ID: 'USER_USER_ID_FIK',
  NOTIF_USER_EMAILS: 'USER_EMAILS_FIK',
  NOTIF_USER_NAME: 'USER_NAME_FIK',
  INSPECTOR_ID: 'INSPECTOR_ID',
  INSPECTOR_USER_ID: 'USER_ID',
  USER_LAN_ID: 'USER_LAN_ID',
  USER_FIRST_NAME: 'USER_FIRST_NAME',
  USER_MIDDLE_NAME: 'USER_MIDDLE_NAME',
  USER_LAST_NAME: 'USER_LAST_NAME',
  USER_SUFFIX: 'USER_SUFFIX',
  USER_IS_ACTIVE: 'USER_IS_ACTIVE',
  SCHEDULE: 'SCHEDULE',
};

export const TIMES_TO_SEND_NOTIF_FI_OPTION_IDS = {
  ALWAYS: 'time-to-send-notif-always',
  BIZ_DAYS: 'time-to-send-notif-biz-days',
  OFF_HOURS: 'time-to-send-notif-off-hours',
  CUSTOM: 'time-to-send-notif-custom',
  CUSTOM_DAYS: 'days',
};

/** Base level keys from a notification from BE */
export const NOTIFICATION_KEYS = {
  NOTIF_ID: 'notifId',
  REQUIREMENTS: 'requirements',
  NAME: 'name',
  DESCRIPTION: 'description',
  IS_ACTIVE: 'isActive',
  DEF_TIME_DISPO: 'defaultTimeDisposition',
  TIMES_TO_SEND_NOTIF: 'timesToSendNotification',
  SCHEDULE: 'schedule',
  LAST_UPDATED: 'lastUpdated',
};

export const REQUIREMENT_KEYS = {
  KEYS: 'keys',
  OPTIONS: 'options',
};

export const TIMES_TO_SEND_NOTIF_KEYS = {
  DAYS_ACTIVE: 'daysActive',
  START_MIN_OFFSET: 'startMinsOffset',
  END_MINS_OFFSET: 'endMinsOffset',
};

export const SCHEDULE_KEYS = {
  RECIPIENT_IDS: 'recipientIds',
  START_TIME: 'startTime',
  END_TIME: 'endTime',
};

export const NOTIF_USER_KEYS = {
  NAME: 'name',
  EMAILS: 'emails',
  USER_ID: 'userId',
  ASSOCIATED_NOTIFS: 'activeNotifs',
  LAST_UPDATED: 'lastUpdated',
};

export const STANDBY_INSPECTOR_KEYS = {
  INSPECTOR_ID: 'id',
  USER_ID: 'user_id',
  USER_OBJECT: 'user',
};

export const USER_KEYS = {
  USER_ID: 'id',
  LAN_ID: 'lan_id',
  FIRST_NAME: 'first_name',
  MIDDLE_NAME: 'middle_name',
  LAST_NAME: 'last_name',
  SUFFIX: 'suffix',
  ACTIVE: 'active',
};

export const TICKET_FIELD_KEYS = {
  REG_CODE: 'pge_regCode',
  PRIORITY: 'priority',
  TYPE: 'type',
};

export const NOTIF_STATUS_KEYS = {
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
};

export const NOTIF_COLUMN_NAMES = {
  NAME: 'name',
  ID: 'id',
  SHORT_DESCRIPTION: 'shortDescription',
  STATUS: 'status',
  BUTTONS: 'buttons',
  STATUS_TEXT: 'statusText',
};

export const NOTIF_COLUMN_LABELS = {
  NAME: 'Name',
  ID: 'Id',
  SHORT_DESCRIPTION: 'Description',
  STATUS: 'Status',
  BUTTONS: 'Actions',
  STATUS_TEXT: 'Status',
};
